
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface NoStaffWarningProps {
  showWarning: boolean;
}

const NoStaffWarning: React.FC<NoStaffWarningProps> = ({ showWarning }) => {
  if (!showWarning) return null;
  
  return (
    <Card className="mb-4 bg-yellow-50 border-yellow-200">
      <CardContent className="p-4">
        <p className="text-yellow-700">
          <span className="font-medium">No AI staff found.</span> You're viewing a demo version of the integrations.
          To get a personalized experience, hire an AI assistant from the Staff page.
        </p>
      </CardContent>
    </Card>
  );
};

export default NoStaffWarning;
